import React from "react"

export const ToggleTagRefinementItem = ({
  label,
  isRefined,
  refine,
  searchState,
}) => {
  const toogle_type = () => {
    if (isRefined) {
      refine(searchState.refinementList.tags.filter((tag) => tag !== label))
    } else {
      refine((searchState?.refinementList?.tags || []).concat(label))
    }
  }

  return (
    <React.Fragment>
      <div
        onClick={toogle_type}
        onKeyPress={() => {}}
        role="button"
        tabIndex="-1"
        aria-label="toggle tag refinement"
        className={`tag has-text-weight-bold internal-search-type-tag ${
          isRefined ? "is-refined" : ""
        } `}
      >
        {label}
      </div>
      <div
        onClick={toogle_type}
        onKeyPress={() => {}}
        role="button"
        tabIndex="-2"
        aria-label="toggle tag refinement 2"
        className={`tag is-delete ${isRefined ? "is-refined" : ""}`}
        style={{ borderLeft: isRefined ? "1px solid #DDD" : "1px solid #444" }}
      ></div>
    </React.Fragment>
  )
}
